@if (intervention().status === 'Closed') {
  <!-- A closed case: how it was closed -->
  <mat-card class="rounded-lg border border-slate-200 p-4 shadow-sm">
    <h2 class="text-lg font-semibold text-slate-900">Case closed</h2>
    <p class="text-sm text-slate-700">
      @if (intervention().closureDate) {
        Closed on {{ intervention().closureDate!.slice(0, 10) }}.
      }
      @if (intervention().closureOutcomeName; as outcome) {
        Outcome: {{ outcome }}.
      }
      @if (intervention().closureReason; as reason) {
        Reason: {{ reason }}
      }
    </p>
  </mat-card>
} @else if (!readOnly() && moves().length > 0) {
  <mat-card class="rounded-lg border border-slate-200 p-4 shadow-sm">
    <h2 class="text-lg font-semibold text-slate-900">Move or close the case</h2>
    <p class="mb-4 text-sm text-slate-600">
      The case moves on as the work is done. Use this to move it on by hand, or to close it.
    </p>
    <form [formGroup]="form" (ngSubmit)="submit()" class="grid gap-4 md:grid-cols-2">
      <mat-form-field appearance="outline" class="md:col-span-2">
        <mat-label>Move the case to</mat-label>
        <mat-select [value]="chosenStage()" (selectionChange)="stageChosen($event.value)">
          @for (stage of moves(); track stage) {
            <mat-option [value]="stage">{{ stageLabel(stage) }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      @if (closing()) {
        <mat-form-field appearance="outline">
          <mat-label>Closure date</mat-label>
          <input matInput [matDatepicker]="closureDatePicker" formControlName="closureDate" />
          <mat-datepicker-toggle matIconSuffix [for]="closureDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #closureDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Closure reason</mat-label>
          <input matInput formControlName="closureReason" />
        </mat-form-field>
        @if (isServiceClosure()) {
          <mat-form-field appearance="outline" class="md:col-span-2">
            <mat-label>Closure outcome *</mat-label>
            <mat-select formControlName="closureOutcomeId">
              @for (item of serviceClosureOutcomes(); track item.id) {
                <mat-option [value]="item.id">{{ item.name ?? item.code }}</mat-option>
              }
            </mat-select>
            <mat-hint>
              Attendance must be verified before closing, unless the outcome is "No initial contact" or "Client dropped out".
            </mat-hint>
          </mat-form-field>
        }
      }

      <div class="flex justify-end md:col-span-2">
        <button mat-flat-button type="submit" [disabled]="busy() || !chosenStage()">
          @if (busy()) {
            <mat-spinner diameter="20" class="mr-2" />
          }
          {{ closing() ? 'Close the case' : 'Move the case' }}
        </button>
      </div>
    </form>
  </mat-card>
}
